import { render, staticRenderFns } from "./CriarIpg.vue?vue&type=template&id=39142bcb&scoped=true"
import script from "./CriarIpg.vue?vue&type=script&lang=js"
export * from "./CriarIpg.vue?vue&type=script&lang=js"
import style0 from "./CriarIpg.vue?vue&type=style&index=0&id=39142bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39142bcb",
  null
  
)

export default component.exports